// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ForgottenPassword/style.css
 ** module id = 1606
 ** module chunks = 0
 **/